import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { TabularReportScreen } from '@/components/tabular-report/tabular-report-screen'
import { hasGrant } from '@/lib/me'

const date = (value: unknown) =>
  typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : undefined

/**
 * Route shell for a supplier's statement (WP09): what the company owed at the
 * start of the period, each posted entry, and what it owes at the end. The
 * period lives in the URL. The grant guard is presentation only.
 */
export const Route = createFileRoute('/_authenticated/accounting/supplier-statement/$supplierId')({
  validateSearch: (search: Record<string, unknown>) => ({
    from: date(search.from),
    to: date(search.to),
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_payment.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: SupplierStatementRoute,
})

function SupplierStatementRoute() {
  const { supplierId } = Route.useParams()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <TabularReportScreen
      path={`/accounting/suppliers/${supplierId}/statement`}
      trail={[{ label: 'common:rail.company.sections.accounting', href: '/accounting' }]}
      search={Route.useSearch()}
      onSearchChange={(next) => void navigate({ search: { from: next.from, to: next.to } })}
      period="range"
      exportPermission="accounting_report.export"
    />
  )
}
